module.exports = __webpack_public_path__ + "img/water balance.7c83c6e5.png";